// Website-Statistik (v3.148.0) — reine Entscheidung, ob ein Seitenaufruf gemeldet wird.
// Ohne Firebase-Import, aus Jest direkt testbar. Aufrufer: components/PageViewTracker.js.

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]', '']);

// Do-Not-Track bzw. Global Privacy Control respektieren wir als Widerspruch.
export function hasOptedOut(nav = {}) {
  return nav.doNotTrack === '1' || nav.globalPrivacyControl === true;
}

export function shouldTrack({ pathname, hostname, nav, useEmulators = false }) {
  if (typeof pathname !== 'string' || !pathname) return false;
  if (pathname === '/admin' || pathname.startsWith('/admin/')) return false;
  if (hasOptedOut(nav)) return false;
  // Lokal laeuft das Frontend standardmaessig gegen die PRODUKTIONS-Functions —
  // ohne diese Sperre landeten Entwicklungs-Klicks in den echten Zahlen.
  if (LOCAL_HOSTS.has(hostname) && !useEmulators) return false;
  return true;
}

// Herkunft nur, wenn sie von aussen kommt — interne Verweise sind kein Einstieg.
export function externalReferrer(referrer, ownHost) {
  if (!referrer) return '';
  try {
    return new URL(referrer).host === ownHost ? '' : referrer;
  } catch {
    return '';
  }
}
